// ============================================================
// Token / 用户信息的便捷封装
// 数据走 storage；三端靠不同 origin（端口 / 域名）隔离。
// Token 的 localStorage key 为 authorization；请求头仍拼 Authorization: Bearer …
// ============================================================
import { storage } from "./storage";

const TOKEN_KEY = "authorization";
const USER_INFO_KEY = "userInfo";

export function getToken(): string {
    return storage.get<string>(TOKEN_KEY) || "";
}

export function setToken(token: string): void {
    storage.set(TOKEN_KEY, token);
}

export function removeToken(): void {
    storage.remove(TOKEN_KEY);
}

export function getUserInfoCache<T = unknown>(): T | null {
    return storage.get<T>(USER_INFO_KEY);
}

export function setUserInfoCache(info: unknown): void {
    storage.set(USER_INFO_KEY, info);
}

export function removeUserInfoCache(): void {
    storage.remove(USER_INFO_KEY);
}
